/**
 * Русский словарь лендинга (язык по умолчанию).
 * Структура — единый источник типов для uz/en (LandingSchema).
 */
const ru = {
  meta: {
    title: 'Hubario — хаб вашей Telegram-переписки',
    description:
      'Hubario — хаб вашей Telegram-переписки: все чаты в одном месте, голосовые с расшифровкой, упоминания и ИИ-анализ.',
    ogDescription: 'Все чаты в одном месте, голосовые с расшифровкой, упоминания и ИИ-анализ.',
    ogLocale: 'ru_RU',
  },
  nav: {
    how: 'Как работает',
    features: 'Возможности',
  },
  header: {
    login: 'Войти',
    start: 'Начать бесплатно',
  },
  hero: {
    badge: 'Telegram-переписка под контролем',
    title1: 'Весь ваш Telegram —',
    title2: 'в одном хабе',
    sub: 'Hubario собирает вашу переписку: чаты, группы, каналы, голосовые. Ничего не теряется — а нужное уходит на ИИ-анализ.',
    ctaPrimary: 'Начать бесплатно',
    ctaSecondary: 'Как это работает',
  },
  how: {
    title: 'Как это работает',
    steps: [
      {
        title: 'Войдите через Google',
        text: 'Аккаунт создаётся автоматически при первом входе — никаких карт, паролей и установок.',
      },
      {
        title: 'Подключите Telegram',
        text: 'Отсканируйте QR-код в приложении Telegram — переписка начнёт собираться автоматически.',
      },
      {
        title: 'Управляйте и анализируйте',
        text: 'Включайте нужные чаты, находите упоминания, отправляйте выбранное на ИИ-анализ.',
      },
    ],
  },
  features: {
    title: 'Возможности',
    items: [
      {
        title: 'Все чаты в одном месте',
        text: 'Личные диалоги, группы и каналы — единая лента с поиском и фильтрами.',
      },
      {
        title: 'Голосовые — текстом',
        text: 'Голосовые сообщения сохраняются и расшифровываются в текст автоматически.',
      },
      {
        title: 'Упоминания не теряются',
        text: 'Все сообщения, где вас упомянули или вам ответили, — в отдельной выборке.',
      },
      {
        title: 'История и правки',
        text: 'Отредактированные и удалённые сообщения сохраняют исходные версии.',
      },
      {
        title: 'Пакеты на ИИ-анализ',
        text: 'Выберите чаты и период — получите выжимку: задачи, договорённости, события.',
      },
      {
        title: 'Безопасность',
        text: 'Доступ к Telegram шифруется, данные принадлежат только вам. Только чтение — никаких действий от вашего имени.',
      },
    ],
  },
  cta: {
    title: 'Попробуйте Hubario сегодня',
    text: 'Вход через Google за минуту, подключение Telegram — по QR-коду.',
    button: 'Начать бесплатно',
  },
  footer: {
    tagline: 'hubario.com — хаб вашей Telegram-переписки',
  },
}

export default ru
export type LandingSchema = typeof ru
